import { useEffect } from "react";

function isEditableTarget(el: EventTarget | null) {
  if (!(el instanceof HTMLElement)) return false;
  const tag = el.tagName.toLowerCase();
  if (tag === "input" || tag === "textarea" || tag === "select") return true;
  if (el.isContentEditable) return true;
  return false;
}

export function useGlobalHotkeys(opts: {
  enabled: boolean;
  onOpen: () => void;
  onClose: () => void;
}) {
  const { enabled, onOpen, onClose } = opts;

  useEffect(() => {
    if (!enabled) return;

    const onKeyDown = (e: KeyboardEvent) => {
      // avoid stealing keystrokes in inputs/textareas
      if (isEditableTarget(e.target)) return;

      // Cmd/Ctrl+K (common)
      const openK = (e.metaKey || e.ctrlKey) && e.key.toLowerCase() === "k";

      // Cmd+Space (Spotlight-like). Note: sometimes OS/browser reserves this.
      const openSpace = e.metaKey && e.code === "Space";

      if (openK || openSpace) {
        e.preventDefault();
        onOpen();
        return;
      }

      if (e.key === "Escape") {
        onClose();
      }
    };

    window.addEventListener("keydown", onKeyDown, { capture: true });

    return () =>
      window.removeEventListener("keydown", onKeyDown, {
        capture: true,
      });
  }, [enabled, onOpen, onClose]);
}
